import { FeatureMainProps } from '../../../../components/Features/FeatureMain/types'

export const pageData: FeatureMainProps = {
    accentColor: '#be2f30',
    pc: {
        background: '/features/ego-20261109/pc_bg.jpg',
        overlay: 'rgba(241, 182, 65, 0.85)',
        eyebrow: '求人特集',
        titleLines: ['株式会社', 'Ego'],
        contentsColor: '#be2f30',
    },
    hero: {
        image: '/features/ego-20261109/hero.jpg',
        alt: '株式会社Ego 求人特集 ネオ大衆居酒屋「肉のウヱキ」 スタッフ募集！',
        analyticsLabel: 'FV',
    },
    headline: {
        title: [
            { text: '「あらゆる人の' },
            { text: '幸せに関わる日本一の', breakBefore: true },
            { text: '“おもてなし”集団', accent: true, breakBefore: true },
            { text: '」' },
        ],
        paragraphs: [
            { text: '「日本の食文化を絶やさずに、' },
            { text: '飲食を通して人を喜ばせ、', breakBefore: true },
            { text: '多くの人に飲食店を利用してほしい！」', breakBefore: true },
            {
                text: 'コロナ禍という逆境の中、こうした想いのもと',
                breakBefore: true,
            },
            { text: '2021年4月に設立しました。', breakBefore: true },
        ],
    },
    thumbnail: {
        image: '/features/ego-20261109/top_sub.jpg',
        alt: 'コロッケの紙袋、ひき肉をのせた一品、クリームチーズとクラッカー',
    },
    featuresTitle: ['Egoで働く魅力'],
    featuresTitleAnalyticsLabel: 'CT_Charm_働く魅力-タイトル',
    features: [
        {
            heading: ['社員定着率9割超！', '温かくてフラットな社風'],
            body: [
                '自由に意見が言い合える、温かくてフラットな社風なので、本当にみんな仲が良いです！ありがたいことに長年勤めてくれているスタッフも多く、"人が辞めない会社"として、人間関係はとにかく良好といえるでしょう！',
            ],
            image: '/features/ego-20261109/section_01.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-1st',
        },
        {
            heading: ['自分でお店を創る！', '個々の裁量権が大きい'],
            body: [
                '「肉のウヱキ」では個々の裁量権が大きいのが特徴です。もちろんコンセプトは守っていってほしいですが、メニュー考案や仕入れ先の選定なども各店舗ごとに任せています。',
            ],
            image: '/features/ego-20261109/section_02.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-2nd',
        },
        {
            heading: ['キャリアは無限大！', '独立も大歓迎！'],
            body: [
                '私たちのところでは、いい意味でキャリアが決まっていません。そのため、社員の方たちは「まずは店長を目指す！」必要も特別ないです。将来独立を考えているなら、オーナーがしっかりとマネジメントや経営ノウハウも教えていきます！',
            ],
            image: '/features/ego-20261109/section_03.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-3rd',
        },
    ],
    jobs: {
        eyebrow: 'pickup',
        title: ['Ego 求人特集'],
        analyticsLabel: 'CT_Jobinformation_求人特集-タイトル',
        categories: [
            {
                id: 'manager',
                categoryLabel: '店長・店長候補',
                variant: 'carousel',
                description:
                    '人気居酒屋の経営を学べる環境で、裁量権を持って働けます。労働環境も良く、独立希望も大歓迎。若手が活躍しています。',
                jobs: [
                    {
                        offerId: '123087',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜店長・店長候補',
                        title: '【新店の店長候補を募集！】若手活躍中＊労働環境良し＊定着率9割以上',
                        brandName: 'フライ＆デリカ 肉のウヱキ 潮見店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '江東区',
                        image: '/features/ego-20261109/job_card_01_01.jpg',
                        href: 'https://foods-labo.com/offers/123087',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-店長・店長候補-1st',
                    },
                    {
                        offerId: '99282',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜店長・店長候補',
                        title: '＜店長候補＞人気居酒屋の経営学べる環境で裁量権をもって働けます！／代々木',
                        brandName: 'フライ＆デリカ 肉のウヱキ 代々木店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '渋谷区',
                        image: '/features/ego-20261109/job_card_01_02.jpg',
                        href: 'https://foods-labo.com/offers/99282',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-店長・店長候補-2nd',
                    },
                    {
                        offerId: '99272',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜店長・店長候補',
                        title: '【社員定着率9割超！】レトロな雰囲気が人気のネオ大衆居酒屋／店長候補',
                        brandName: 'フライ＆デリカ 肉のウヱキ 五反田店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '品川区',
                        image: '/features/ego-20261109/job_card_01_03.jpg',
                        href: 'https://foods-labo.com/offers/99272',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-店長・店長候補-3rd',
                    },
                    {
                        offerId: '99277',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜店長・店長候補',
                        title: '【裁量権あり！独立希望大歓迎！】地域で愛されるレトロな大衆居酒屋／店長候補',
                        brandName: 'フライ＆デリカ 肉のウヱキ 新木場店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '江東区',
                        image: '/features/ego-20261109/job_card_01_04.jpg',
                        href: 'https://foods-labo.com/offers/99277',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-店長・店長候補-4th',
                    },
                    {
                        offerId: '99267',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜店長・店長候補',
                        title: '【若手活躍中＊キャリアは自分で作る！】昭和レトロなネオ大衆居酒屋の店長候補',
                        brandName:
                            'フライ＆デリカ 肉のウヱキ 千葉ニュータウン店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '印西市',
                        image: '/features/ego-20261109/job_card_01_05.jpg',
                        href: 'https://foods-labo.com/offers/99267',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-店長・店長候補-5th',
                    },
                ],
            },
            {
                id: 'chef',
                categoryLabel: '料理長・料理長候補',
                variant: 'carousel',
                description:
                    '調理経験者歓迎。経験を活かして即戦力として活躍できます。店舗限定メニューの企画・考案などもおこなっています。',
                jobs: [
                    {
                        offerId: '123088',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜料理長・料理長候補',
                        title: '【江東区＊大衆居酒屋の新店】経験活かせます＊キャリア充実＊高い定着率',
                        brandName: 'フライ＆デリカ 肉のウヱキ 潮見店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '江東区',
                        image: '/features/ego-20261109/job_card_02_01.jpg',
                        href: 'https://foods-labo.com/offers/123088',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-料理長・料理長候補-1st',
                    },
                    {
                        offerId: '99283',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜料理長・料理長候補',
                        title: '【経験を活かして即戦力として活躍！】働きやすさ◎高定着率のレトロ大衆居酒屋',
                        brandName: 'フライ＆デリカ 肉のウヱキ 代々木店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '渋谷区',
                        image: '/features/ego-20261109/job_card_02_02.jpg',
                        href: 'https://foods-labo.com/offers/99283',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-料理長・料理長候補-2nd',
                    },
                    {
                        offerId: '99273',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜料理長・料理長候補',
                        title: '＜即戦力歓迎！働きやすさが自慢！＞レトロ可愛い大衆居酒屋／五反田駅チカ',
                        brandName: 'フライ＆デリカ 肉のウヱキ 五反田店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '品川区',
                        image: '/features/ego-20261109/job_card_02_03.jpg',
                        href: 'https://foods-labo.com/offers/99273',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-料理長・料理長候補-3rd',
                    },
                    {
                        offerId: '99278',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜料理長・料理長候補',
                        title: '《自分でお店を創る！独立希望大歓迎！》人気居酒屋の経営ノウハウが学べます◎',
                        brandName: 'フライ＆デリカ 肉のウヱキ 新木場店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '江東区',
                        image: '/features/ego-20261109/job_card_02_04.jpg',
                        href: 'https://foods-labo.com/offers/99278',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-料理長・料理長候補-4th',
                    },
                    {
                        offerId: '99268',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜料理長・料理長候補',
                        title: '【調理経験者歓迎＊働きやすい職場】昭和レトロなネオ大衆居酒屋｜千葉県印西市',
                        brandName:
                            'フライ＆デリカ 肉のウヱキ 千葉ニュータウン店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '印西市',
                        image: '/features/ego-20261109/job_card_02_05.jpg',
                        href: 'https://foods-labo.com/offers/99268',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-料理長・料理長候補-5th',
                    },
                ],
            },
            {
                id: 'hall',
                categoryLabel: 'ホールスタッフ',
                variant: 'carousel',
                description:
                    '未経験OKの求人もあり。昭和レトロで居心地が良く、誰でも入りやすい雰囲気で、多くの方々にご利用いただいています。',
                jobs: [
                    {
                        offerId: '123089',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜レストランサービス・ホールスタッフ',
                        title: '《新店の社員スタッフ募集‼️》未経験OK＊転居補助・家賃半額＊若手活躍中',
                        brandName: 'フライ＆デリカ 肉のウヱキ 潮見店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '江東区',
                        image: '/features/ego-20261109/job_card_03_01.jpg',
                        href: 'https://foods-labo.com/offers/123089',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-1st',
                    },
                    {
                        offerId: '99279',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜レストランサービス・ホールスタッフ',
                        title: '＜キャリアプラン無限大！＞人気店「肉のウヱキ」で活躍しませんか？／新木場',
                        brandName: 'フライ＆デリカ 肉のウヱキ 新木場店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '江東区',
                        image: '/features/ego-20261109/job_card_03_02.jpg',
                        href: 'https://foods-labo.com/offers/99279',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-2nd',
                    },
                    {
                        offerId: '99284',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜レストランサービス・ホールスタッフ',
                        title: '《キャリアアップ×社員定着率9割超》レトロなネオ大衆居酒屋の店舗STAFF',
                        brandName: 'フライ＆デリカ 肉のウヱキ 代々木店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '渋谷区',
                        image: '/features/ego-20261109/job_card_03_03.jpg',
                        href: 'https://foods-labo.com/offers/99284',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-3rd',
                    },
                    {
                        offerId: '99274',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜レストランサービス・ホールスタッフ',
                        title: '《未経験大歓迎！経験者はすぐに即戦力に！》大衆居酒屋の店舗STAFFを募集',
                        brandName: 'フライ＆デリカ 肉のウヱキ 五反田店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '品川区',
                        image: '/features/ego-20261109/job_card_03_04.jpg',
                        href: 'https://foods-labo.com/offers/99274',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-4th',
                    },
                    {
                        offerId: '99269',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜レストランサービス・ホールスタッフ',
                        title: '《飲食未経験大歓迎＊高い定着率が自慢！》地域に密着した人気店「肉のウヱキ」',
                        brandName:
                            'フライ＆デリカ 肉のウヱキ 千葉ニュータウン店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '印西市',
                        image: '/features/ego-20261109/job_card_03_05.jpg',
                        href: 'https://foods-labo.com/offers/99269',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-5th',
                    },
                ],
            },
            {
                id: 'kitchen',
                categoryLabel: 'キッチンスタッフ',
                variant: 'carousel',
                description:
                    'コロッケやメンチカツなど、お肉屋さんの揚げ物やお惣菜が中心のメニュー。手作り率を高くして、真心込めて作っています。',
                jobs: [
                    {
                        offerId: '123090',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜キッチンスタッフ',
                        title: '《人気大衆居酒屋「肉のウヱキ」の新店！》未経験OK＊労働環境◎＊転居補助',
                        brandName: 'フライ＆デリカ 肉のウヱキ 潮見店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '江東区',
                        image: '/features/ego-20261109/job_card_04_01.jpg',
                        href: 'https://foods-labo.com/offers/123090',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-1st',
                    },
                    {
                        offerId: '99285',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜キッチンスタッフ',
                        title: '《裁量権を持って自分でお店を創る！》大衆居酒屋「肉のウヱキ」STAFF募集',
                        brandName: 'フライ＆デリカ 肉のウヱキ 代々木店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '渋谷区',
                        image: '/features/ego-20261109/job_card_04_02.jpg',
                        href: 'https://foods-labo.com/offers/99285',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-2nd',
                    },
                    {
                        offerId: '99275',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜キッチンスタッフ',
                        title: '《キャリアプランは無限大！独立も大歓迎！》地域で愛される大衆居酒屋｜五反田',
                        brandName: 'フライ＆デリカ 肉のウヱキ 五反田店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '品川区',
                        image: '/features/ego-20261109/job_card_04_03.jpg',
                        href: 'https://foods-labo.com/offers/99275',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-3rd',
                    },
                    {
                        offerId: '99280',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜キッチンスタッフ',
                        title: '【調理経験者大歓迎＊働きやすさ◎】新木場エリアで地域に根付いた大衆居酒屋',
                        brandName: 'フライ＆デリカ 肉のウヱキ 新木場店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '江東区',
                        image: '/features/ego-20261109/job_card_04_04.jpg',
                        href: 'https://foods-labo.com/offers/99280',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-4th',
                    },
                    {
                        offerId: '99270',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜キッチンスタッフ',
                        title: '【飲食の楽しさを！働きやすい職場！】スタッフ募集／地域に根付いた大衆居酒屋',
                        brandName:
                            'フライ＆デリカ 肉のウヱキ 千葉ニュータウン店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '印西市',
                        image: '/features/ego-20261109/job_card_04_05.jpg',
                        href: 'https://foods-labo.com/offers/99270',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-5th',
                    },
                ],
            },
            {
                id: 'assistant',
                categoryLabel: '調理見習い・調理補助',
                variant: 'carousel',
                description:
                    '週休2日の求人もあり。未経験からキャリアアップを目指せます。10代〜30代前半の若手が中心となり、お店を盛り上げています。',
                jobs: [
                    {
                        offerId: '123091',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜調理見習い・調理補助',
                        title: '【若手募集＊週休2日＊定着率9割以上】地域密着ブランド「肉のウヱキ」新店',
                        brandName: 'フライ＆デリカ 肉のウヱキ 潮見店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '江東区',
                        image: '/features/ego-20261109/job_card_05_01.jpg',
                        href: 'https://foods-labo.com/offers/123091',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理見習い・調理補助-1st',
                    },
                    {
                        offerId: '99286',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜調理見習い・調理補助',
                        title: '＜未経験からキャリアアップ目指せる！＞居酒屋「肉のウヱキ」の若手STAFF',
                        brandName: 'フライ＆デリカ 肉のウヱキ 代々木店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '渋谷区',
                        image: '/features/ego-20261109/job_card_05_02.jpg',
                        href: 'https://foods-labo.com/offers/99286',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理見習い・調理補助-2nd',
                    },
                    {
                        offerId: '99281',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜調理見習い・調理補助',
                        title: '《若手採用強化中！》POPでかわいいネオ大衆居酒屋のSTAFF募集／新木場',
                        brandName: 'フライ＆デリカ 肉のウヱキ 新木場店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '江東区',
                        image: '/features/ego-20261109/job_card_05_03.jpg',
                        href: 'https://foods-labo.com/offers/99281',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理見習い・調理補助-3rd',
                    },
                    {
                        offerId: '99276',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜調理見習い・調理補助',
                        title: '【飲食をやりたい！の気持ちがあればOK】おしゃれレトロな大衆居酒屋／五反田',
                        brandName: 'フライ＆デリカ 肉のウヱキ 五反田店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '品川区',
                        image: '/features/ego-20261109/job_card_05_04.jpg',
                        href: 'https://foods-labo.com/offers/99276',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理見習い・調理補助-4th',
                    },
                    {
                        offerId: '99271',
                        badgeLabel:
                            '居酒屋,テイクアウト・惣菜・弁当屋｜調理見習い・調理補助',
                        title: '《若手が活躍できる職場＊未経験OK》POPでレトロな人気大衆居酒屋｜印西市',
                        brandName:
                            'フライ＆デリカ 肉のウヱキ 千葉ニュータウン店',
                        brandLogo: '/features/ego-20261109/logo_01.png',
                        salary: '25~35',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '印西市',
                        image: '/features/ego-20261109/job_card_05_05.jpg',
                        href: 'https://foods-labo.com/offers/99271',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理見習い・調理補助-5th',
                    },
                ],
            },
        ],
    },
    floatingCta: {
        label: '求人一覧を見る',
        analyticsLabel: 'CT_Jobinformation_追従CTA',
    },
}
